import {ChangeEvent, useContext, useState} from 'react';
import {Box, TextField} from '@mui/material';
import {AccueilContext} from '../../contexts/AccueilContext';
import {useTranslation} from '../../contexts/LanguageContext';

const PlayerNameInput = () => {
    const [inputValue, setInputValue] = useState('');
    const accueilContext = useContext(AccueilContext);
    const { t } = useTranslation();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        accueilContext.setPlayerName(event.target.value);
        localStorage.setItem("pendingGamePlayerName", event.target.value);
    };

    return (
            <Box
                display="flex"
                alignItems="center"
                sx={{
                    borderRadius:1,
                    backgroundImage: 'url(/images/buttons/menuButton2.png)',
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: { xs: 52, md: 48 },
                    width: { xs: '70%', sm: '50%', md: '30%' },
                    '&:hover': {
                        backgroundImage: 'url(/images/buttons/menuButton2_hover.png), url(/images/buttons/menuButton2.png)'
                    }
                }}
            >
                <TextField
                    value={inputValue}
                    onChange={handleChange}
                    required
                    placeholder={t('pseudo')}
                    variant="standard"
                    margin="none"
                    inputProps={{ maxLength: 4, style: { fontSize: 20, textAlign: 'center', fontStyle: 'italic' } }}
                    sx={{ input: { color: 'black' }, width: '100%' }}
                    InputProps={{
                        disableUnderline: true
                    }}
                />
            </Box>
    );
};

export default PlayerNameInput;
